import React from 'react';
import PropTypes from 'prop-types';
const _ = {
    find:       require('lodash/find'),
    map:        require('lodash/map'),
    forEach:    require('lodash/forEach'),
}

// const Globals = require('../../../../../app/globals');
const ShortCourseConstants = require('../../../../../app/shared/ShortCourseConstants');

const propTypes = {
    playStore: PropTypes.object.isRequired,
};

//import ChatBot from '../../ChatBot.js';

// This component is shown when playing a course 
class ShortCourseSkillPanel extends React.Component {
    constructor(props) {
        super(props);
        const doc = props.playStore.getDoc();
        let nodesInOrder = props.playStore.getNodesInOrder();
        let storeState = this.getStoreState(props);
        this.state = {...storeState,
            nodesInOrder: nodesInOrder,
            node_description_expanded: {},
            subskill_expanded: {},
        };
        this.unsubscribes = [this.props.playStore.getStore().listen(this.onPlayChange)];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    getStoreState=(props)=>{
        const doc = props.playStore.getDoc();
        let playStoreState = props.playStore.getStore().getState();
        let flowFocus = playStoreState.flowFocus;
        let node_id = playStoreState.node_id;
        let subskills,node_gate,node_min_gate,node_max_gate,remediating;

        var { attemptData, latestAssessmentAttemptData }  = props.playStore.getLastAttemptData();
        
        if (node_id) {
            subskills = props.playStore.getNodeSubskillStates(node_id);
            let { gate, min_gate, max_gate, remediating:r } = props.playStore.getNodeGateStatus(node_id);
            node_gate = gate;
            node_min_gate = min_gate;
            node_max_gate = max_gate;
            remediating = r;
        }

        let activePhase = props.playStore.getReportCardActivePhase(); // if the grade card is active and in a phase where checks should be hidden
        let reportCardState = null;
        if (activePhase !== null) {
            if (latestAssessmentAttemptData && latestAssessmentAttemptData.activityTypeObj) {
                reportCardState = {
                    hideChecks: (activePhase < ShortCourseConstants.REPORT_CARD_PHASE.HIGHLIGHT_FAILED),
                    star_level: latestAssessmentAttemptData.activityTypeObj.gate - 1, // star_level is 0 to 2 (matches this component's "gate" range)
                }
            }
        }
        
        let complete_count = 0;
        let total_count = 0;
        _.forEach(doc.nodes,(node)=>{
            total_count++;
            if (props.playStore.isNodeComplete(node.node_id)) {
                complete_count++;
            }
            else if ((node_id === node.node_id) && node_gate) {
                complete_count += ((node_gate-1) / 3);
            }
        });
        let percentComplete = total_count ? complete_count * 100 / total_count : 50;
        if (percentComplete < 0) {
            percentComplete = 0;
        }
        else if (percentComplete > 100) {
            percentComplete = 100;
        }
        
        // state updates
        let node_expanded = {};
        if (node_id) {
            node_expanded[node_id] = true;
        }
        if (this.state) {
            if (node_id === this.state.node_id) {
                node_expanded = this.state.node_expanded;
            }
        }
            
        var selectedStar = reportCardState ? reportCardState.star_level : (node_gate - 1);
        
        return { flowFocus, node_id, subskills, node_gate, node_min_gate, node_max_gate, remediating, percentComplete, node_expanded, selectedStar,
            reportCardState, attemptData,
        }
    }

    onPlayChange=(storeState)=>{
        this.setState(this.getStoreState(this.props));
    }
    
    renderPercentArc=()=>{
        // console.log(`percentComplete ${this.state.percentComplete} degrees=${(a * 180 / Math.PI).toFixed(1)} x1,y1=(${e1x},${e1y}  x2,y2=(${e2x},${e2y})`);
        let svgElem;
        const strokeColor = "white"; // "#0E2448";
        const fillColor = "white"; // "#0E2448";
        let outlineElem;
        if (this.state.percentComplete < 100) {
            const cx = 50;
            const cy = 50;
            const r1 = 0; //30;
            const r2 = 40;
            const xAxisRot = 0;
            const largeArcFlag = (this.state.percentComplete < 50) ? 0 : 1; // small or large arc
            const sweepCW = 1;
            const sweepCCW = 0;
            const a = (Math.PI * 0.5) - 2 * Math.PI * this.state.percentComplete / 100;
            const e1x = cx + Math.cos(a) * r1;
            const e1y = cy - Math.sin(a) * r1;
            const e2x = cx + Math.cos(a) * r2;
            const e2y = cy - Math.sin(a) * r2;
            let path_str =`M${cx} ${cy-r1} L${cx} ${cy-r2} A${r2} ${r2} ${xAxisRot} ${largeArcFlag} ${sweepCW} ${e2x} ${e2y} L${e1x} ${e1y} A${r1} ${r1} ${xAxisRot} ${largeArcFlag} ${sweepCCW} ${cx} ${cy-r1} Z`;
            svgElem=(<path d={path_str} stroke={strokeColor} fill={fillColor} strokeWidth="1"/>);
            outlineElem=(<circle cx="50" cy="50" r="40" stroke={strokeColor} strokeWidth="1" fill="none" />);
        }
        else {
            svgElem=(
                <circle cx="50" cy="50" r="40" stroke={strokeColor} fill="white" />
            );
            outlineElem = null;
        }

        return (
            <div className="percent-arc">
                <svg height="100%" width="100%" viewBox="0 0 100 100">
                    {svgElem}
                    {outlineElem}
                </svg>
            </div>
        );
    }

    /*getPercentComplete=(gate,min_gate,max_gate,remediating)=>{
        let percentComplete = 100 * ( gate - remediating * 0.5 - min_gate) / Math.max(1,(max_gate - min_gate));
        if (percentComplete < 0) {
            percentComplete = 0;
        }
        else if (percentComplete > 100) {
            percentComplete = 100;
        }
        return percentComplete;
    }*/
    
    renderCourseProgressHeader=()=>{
        const doc = this.props.playStore.getDoc();
        return (
            <h1>
                <span>{doc.course_title}</span>
                <div className="percent-complete-ui">
                    <div className="pie">
                        {this.renderPercentArc()}
                    </div>
                    <div className="text">
                        <span>
                            {Math.floor(this.state.percentComplete) + '%'}
                        </span>
                    </div>
                </div>
            </h1>
        );
    }
    
    toggleSubskillExpanded=(hash)=>{
        let subskill_expanded = {...this.state.subskill_expanded};
        subskill_expanded[hash] = subskill_expanded[hash] ? false : true;
        this.setState({subskill_expanded});
    }

    toggleNodeExpanded=(node_id)=>{
        let node_expanded = {...this.state.node_expanded};
        node_expanded[node_id] = node_expanded[node_id] ? false : true;
        this.setState({node_expanded});
    }
    
    toggleNodeDescriptionExpanded=(evt,node_id)=>{
        evt.stopPropagation();
        let node_expanded = this.state.node_expanded;
        let node_description_expanded = {...this.state.node_description_expanded};
        let expanded = node_description_expanded[node_id] = node_description_expanded[node_id] ? false : true;
        if (expanded) {
            if (!node_expanded[node_id]) {
                node_expanded = {...node_expanded};
                node_expanded[node_id] = node_expanded[node_id] ? false : true;
            }
        }
        this.setState({node_expanded, node_description_expanded});
    }

    selectStar=(star)=>{
        if (this.state.selectedStar != star) {
            this.setState({selectedStar: star});
        }
    }

    renderStars=(node_id)=>{
        if (typeof this.state.node_gate == 'undefined' || node_id !== this.state.node_id) {
            return null;
        }

        var starLevel = this.state.node_gate - 1;
        
        if (this.state.reportCardState && this.state.reportCardState.hideChecks) {
            starLevel = Math.max(starLevel - 1, 0);
        }

        var initialStarState = "completed";
        var preTestStarState = "completed";
        var finalStarState = "completed";

        switch (starLevel) {
            case 0:
                initialStarState = "active";
                preTestStarState = "locked";
                finalStarState = "locked";
                break;
            case 1:
                initialStarState = "completed";
                preTestStarState = "active";
                finalStarState = "locked";
                break;
            case 2:
                initialStarState = "completed";
                preTestStarState = "completed";
                finalStarState = "active";
                break;
        }

        var selectedStar = this.state.selectedStar;
        
        var initialStarClasses = "initial star";
        var preTestStarClasses = "pre-test star";
        var finalStarClasses = "final star";
        switch (selectedStar) {
            case 0:
                initialStarClasses += " active";
                break;
            case 1:
                preTestStarClasses += " active";
                break;
            case 2:
                finalStarClasses += " active";
                break;
        }
        
        return (
            <div className="subskill-stars">
                <div className={initialStarClasses} title={initialStarState} onClick={()=>{this.selectStar(0)}}>
                    <img className={initialStarState} src={`${GlobalConfig.StaticUrl}/img/courses/${initialStarState}_star.svg`} aria-hidden />
                    <span>Beginner</span>
                </div>
                <div className={preTestStarClasses} title={preTestStarState} onClick={()=>{this.selectStar(1)}}>
                    <img className={preTestStarState} src={`${GlobalConfig.StaticUrl}/img/courses/${preTestStarState}_star.svg`} aria-hidden />
                    <span>Intermediate</span>
                </div>
                <div className={finalStarClasses} title={finalStarState} onClick={()=>{this.selectStar(2)}}>
                    <img className={finalStarState} src={`${GlobalConfig.StaticUrl}/img/courses/${finalStarState}_star.svg`} aria-hidden />
                    <span>Proficient</span>
                </div>
            </div>
        );
    }

    renderSubskills=(node_id)=>{
        let minGate = this.state.node_min_gate||0
        let endGate = this.state.node_max_gate||0; // TODO what is endGate used for?
        if (endGate < 1) {
            endGate = 1;
        }

        var selectedStar = this.state.selectedStar;
        const attemptData = this.state.attemptData;

        var allFull = selectedStar !== null && selectedStar <  this.state.node_gate - 1;
        var allEmpty = selectedStar !== null && selectedStar >  this.state.node_gate - 1;

        let subskills = this.state.subskills;
        if (node_id !== this.state.node_id) {
            subskills = this.props.playStore.getNodeSubskillStates(node_id);
            allFull = false;
            allEmpty = false;
        }

        var reportCardState = this.state.reportCardState;
        if (reportCardState && (reportCardState.star_level !== selectedStar)) {
            reportCardState = null; // don't use reportCardState if the selectedStar isn't on the same level
        }

            
        return (
            <div className="subskills">
                {subskills.map((ss,index)=>{
                    var boxChecked = true;
                    if (!allFull && ( allEmpty || ((ss.gate <= this.state.node_gate) && (ss.attempts === 0 || ss.remediating) ) ) ) {
                        boxChecked = false;
                    }
                    
                    if (reportCardState) {
                        // use attemptData to determine star state
                        if (attemptData) {
                            let si = _.find(attemptData.skillsInvolved,(si)=>(si.subskill.hash === ss.hash));
                            if (si) {
                                boxChecked = reportCardState.hideChecks ? false : si.passed; // hide the check until the report card shows it
                            }
                            // else the subskill was not involved in the last attempt (use the existing boxChecked value)
                        }
                    }

                    var checkBox = (
                        <div className="skill-checkbox" style={{"--animation-order": index + 1}}>
                            <input id={"ss-checkbox-" + index} type="checkbox" checked={boxChecked} disabled aria-hidden/>
                            <label htmlFor={"ss-checkbox-" + index} className="check-box" />
                        </div>
                    );

                    var vLine = null;
                    if (index < subskills.length - 1) {
                        vLine = (<div className="v-line"></div>);
                    }

                    return (
                        <div key={index} className="subskill-row">
                            <div className={"subskill-name hover-expander"} onClick={()=>{this.toggleSubskillExpanded(ss.hash)} }>
                                {vLine}
                                {checkBox}
                                {ss.display_name}
                                {ss.description ?
                                <i className={this.state.subskill_expanded[ss.hash] ? "fa fa-caret-left down" : "fa fa-caret-left"} aria-hidden="true" /> 
                                : null }
                            </div>
                            { this.state.subskill_expanded[ss.hash] ? 
                            <div className={"subskill-description"}>
                                {ss.description}
                            </div>
                            : null }
                        </div>
                    )
                })}
            </div>
        )
    }

    render() {
        var skillPanelStyle = {};
        if (this.props.top) {
            skillPanelStyle.top = this.props.top;
        }
        if (this.props.left) {
            skillPanelStyle.left = this.props.left;
        }
        return (
            <div className="short-course-skill-panel" style={skillPanelStyle}>
                {this.renderCourseProgressHeader()}
                {/*<ChatBot/>*/}
                <div className="skill-list">
                    {_.map(this.state.nodesInOrder,(node)=>{
                        let active = (node.node_id === this.state.node_id);
                        let expanded = this.state.node_expanded[node.node_id];
                        let description_expanded = this.state.node_description_expanded[node.node_id];
                        return (
                        <div key={node.node_id} className={ active ? "skill-line active" : "skill-line"}>
                            <div className="skill-name" role="button" title={expanded ? "collapse" : "expand"} onClick={()=>{this.toggleNodeExpanded(node.node_id)}} >
                                <div className=" hover-expander">{node.name}
                                    {node.description ?
                                    <i className={description_expanded ? "fa fa-caret-left down" : "fa fa-caret-left"} aria-hidden="true" onClick={(evt)=>{this.toggleNodeDescriptionExpanded(evt,node.node_id)}}/> 
                                    : null }
                                </div>
                            </div>
                            { description_expanded ? 
                            <div className={"skill-description"}>
                                {node.description}
                            </div>
                            : null }
                            {expanded ? this.renderStars(node.node_id) : null }
                            {expanded ? this.renderSubskills(node.node_id) : null }
                        </div>
                        );
                    })}
                </div>
            </div>
        );
    }
};

export default ShortCourseSkillPanel;